<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useSessionStore } from '../../stores/session'

const sessionStore = useSessionStore()
const { isLoggedIn } = storeToRefs(sessionStore)

const doLogout = () => {
  sessionStore.logout()
  window.location.href = '/?notify=logout-success'
}
</script>

<template>
  <ul class="bx-header__user-navi">
    <li v-if="isLoggedIn">
      <a id="nav-subscribe"
         href="/mein-abo"
         class="bx-typo--link">
        Abo
      </a>
    </li>
    <li v-if="!isLoggedIn">
      <a id="nav-register"
         href="/registrieren"
         class="bx-typo--link">
        Registrieren
      </a>
    </li>
    <li v-if="!isLoggedIn">
      <a id="nav-login"
         href="/anmelden"
         class="bx-typo--link">
        Anmelden
      </a>
    </li>
    <li v-else>
      <span id="nav-logout"
            class="bx-typo--link"
            @click="doLogout">
        Abmelden
      </span>
    </li>
  </ul>
</template>
